import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { clickCopy } from '@/utils/public';
import quickConfigurationModal from './quickConfigurationModal.vue';
import Handsontable from 'handsontable';
import 'handsontable/dist/handsontable.full.css';
import { debounce } from 'lodash';
import { widthSetOptins, dateTypeOptions, controlCellOptions, fontSizeSelectOption, fontFamilySelectOption } from './utils';
import { getTemplateDataSources, getFunctionResource, addContainerTemplate, getContainerTemplateDetail, editContainerTemplate } from './request';
let that;
export default {
  data() {
    return {
      tableForm: {
        name: 'table1',
        mark: 'table1',
        tableHead: false,
        tableTail: true,
        autoincrement: false,
        tabHeadLineNum: 1,
        isForm: false,
        sortDefault: false
      },
      autoincrement: false,
      columns: [],
      controlCellOptions: controlCellOptions,
      functionResource: [],
      showFunctionResource: [],
      dataSource: [],
      activeRowIndex: undefined,
      activeColumnIndex: undefined,
      loading: false,
      markDataMap: {},
      configVisiable: false,
      formatSystemData: [],
      formatDynamicData: [],
      formatFilterData: [],
      supportSortMap: {},
      tableInitInfo: {},
      hot: null,
      fontFamilySelectOption: fontFamilySelectOption,
      fontSizeSelectOption: fontSizeSelectOption,
      defaultColumnObj: {
        type: undefined,
        mark: [],
        tail: '',
        function: undefined,
        functionDataSource: this.tableTailFunction || [],
        control: 'text',
        textLengthMinValue: 0,
        textLengthMaxValue: 200,
        numberMinValue: 0,
        numberMaxValue: 200,
        optionValues: '',
        dateType: '',
        widthSet: undefined,
        font: false,
        bold: false,
        italic: false,
        underline: false,
        fontSize: false,
        fontFamily: '默认字体',
        size: '默认字号',
        activeStyleIcon: ''
      },
      columnsNumber: 0,
      rowsNumber: 0,
      cellSettings: {
        selectRowKey: undefined,
        selectColumnKey: undefined,
        cellOptions: [],
        columnOptions: [],
        rowOptions: [],
        activeStyleIcon: ''
      },
      cellStyleObj: {},
      computedCurrentStyleObj: {},
      styleObjDefault: {
        activeStyleIcon: '',
        font: false,
        bold: false,
        italic: false,
        underline: false,
        fontSize: false,
        bgColor: false,
        control: undefined,
        textLengthMinValue: 0,
        textLengthMaxValue: 200,
        preAndLast: [],
        prefix: '',
        suffix: '',
        typeFace: '默认字体',
        size: '默认字号',
        type: '',
        optionValues: '',
        bgColorValue: null,
        textAlign: '',
        valign: 'center'
      },
      headerData: [],
      addPrefixOrSuffixVisible: false,
      prefixOrSuffix: '',
      addType: '',
      mergeCells: [],
      widthSetOptins: widthSetOptins,
      dateTypeOptions: dateTypeOptions
    };
  },
  components: {
    quickConfigurationModal
  },
  async created() {
    that = this;
    this.tableInitInfo = this.$route.params.type === 'template' ? JSON.parse(sessionStorage.getItem('templateTableInitInfo')) : JSON.parse(sessionStorage.getItem('tableInitInfo'));
    let functions = await getFunctionResource({}); //获取关联函数的数据
    this.functionResource = functions;
    this.showFunctionResource = functions && Array.isArray(functions) && functions.filter(item => item.isContainer);
    this.tableTailFunction = functions && Array.isArray(functions) && functions.filter(item => item.isTableTailFunction);
    console.log(this.tableInitInfo.id, this.$route.params.id, 'this.tableInitInfo');
    // debugger;

    if (this.tableInitInfo.id !== -1 && this.tableInitInfo.tableUsage === 'control') {
      //编辑模板
      this.editTable();
    } else if (this.$route.params.id !== -1 && this.tableInitInfo.tableUsage === 'template') {
      this.editTable();
    } else {
      this.newTable(); //新增表格
    }
    if (this.tableInitInfo.tableUsage === 'template') {
      this.generateTableMark();
    } else {
      // this.generateTableMark();
      this.tableForm.mark = this.tableInitInfo.mark;
    }
  },
  computed: {
    dataRule() {
      return {
        name: [
        // {required: true, trigger: 'blur', message: this.$t('请输入') + this.$t('表格名称')},
        {
          min: 1,
          max: 30,
          message: this.$t('表格名称最多支持输入30字符'),
          trigger: 'blur'
        }]
      };
    },
    computedColumns() {
      return this.columns.map((item, index) => {
        let obj = {
          title: item.name,
          dataIndex: item.dataIndex,
          key: item.dataIndex,
          width: 30
        };
        return obj;
      });
    },
    showColumns() {
      return this.columns.filter(item => item.dataIndex !== 'column0');
    },
    sortColumns() {
      return this.columns.filter(item => !this.autoincrement || item.name !== 'column1' && this.autoincrement);
    },
    computedFormatSystemData() {
      if (!this.formatSystemData || !Array.isArray(this.formatSystemData)) {
        return [];
      }
      const loop = data => {
        return data && Array.isArray(data) && data.map(item => {
          if (!item.isLeaf) {
            item.children = loop(item.children);
          }
          return {
            ...item,
            label: !item.isLeaf ? this.$t(item.name) : item.label
          };
        });
      };
      let data = loop(this.formatSystemData);
      return data;
    },
    computedFormatDynamicData() {
      if (!this.formatDynamicData || !Array.isArray(this.formatDynamicData)) {
        return [];
      }
      const loop = data => {
        return data && Array.isArray(data) && data.map(item => {
          if (!item.isLeaf) {
            item.children = loop(item.children);
          }
          return {
            ...item,
            label: !item.isLeaf > 0 ? this.$t(item.name) : item.label
          };
        });
      };
      let data = loop(this.formatDynamicData);
      return data;
    },
    computedFormatFilterData() {
      if (!this.formatFilterData || !Array.isArray(this.formatFilterData)) {
        return [];
      }
      const loop = data => {
        return data && Array.isArray(data) && data.map(item => {
          if (!item.isLeaf) {
            item.children = loop(item.children);
          }
          return {
            ...item,
            label: !item.isLeaf > 0 ? this.$t(item.name) : item.label
          };
        });
      };
      let data = loop(this.formatFilterData);
      return data;
    }
  },
  watch: {
    'cellSettings.selectRowKey': {
      handler: function (val, oldVal) {
        console.log(val, oldVal, 'val,oldVal');
        if ((oldVal || oldVal === 0) && (this.cellSettings.selectColumnKey || this.cellSettings.selectColumnKey === 0) && Object.keys(this.computedCurrentStyleObj).length > 0) {
          let old = oldVal + ',' + this.cellSettings.selectColumnKey;
          this.cellStyleObj[old] = JSON.parse(JSON.stringify(this.computedCurrentStyleObj));
        }
        if ((val || val === 0) && (this.cellSettings.selectColumnKey || this.cellSettings.selectColumnKey === 0)) {
          let current = this.cellSettings.selectRowKey + ',' + this.cellSettings.selectColumnKey;
          let currentObj = this.cellStyleObj[current];
          let allDisabledCell = that.computedDisabledCell();
          if (allDisabledCell.indexOf(current) !== -1) {
            this.computedCurrentStyleObj = {};
            return;
          }
          this.computedCurrentStyleObj = currentObj ? currentObj : {};
        } else {
          this.computedCurrentStyleObj = {};
        }
      }
    },
    'cellSettings.selectColumnKey': {
      handler: function (val, oldVal) {
        // console.log(val, oldVal, 'val,oldVal');
        if ((oldVal || oldVal === 0) && (this.cellSettings.selectRowKey || this.cellSettings.selectRowKey === 0) && Object.keys(this.computedCurrentStyleObj).length > 0) {
          let old = this.cellSettings.selectRowKey + ',' + oldVal;
          this.cellStyleObj[old] = JSON.parse(JSON.stringify(this.computedCurrentStyleObj));
        }
        if ((val || val === 0) && (this.cellSettings.selectRowKey || this.cellSettings.selectRowKey === 0)) {
          let current = this.cellSettings.selectRowKey + ',' + this.cellSettings.selectColumnKey;
          let currentObj = this.cellStyleObj[current];
          let allDisabledCell = that.computedDisabledCell();
          if (allDisabledCell.indexOf(current) !== -1) {
            this.computedCurrentStyleObj = {};
            return;
          }
          this.computedCurrentStyleObj = currentObj ? currentObj : {};
        } else {
          this.computedCurrentStyleObj = {};
        }
      }
    }
  },
  mounted() {
    this.debounceCalcScroll = debounce(this.updateTble, 500);
    window.addEventListener('resize', this.debounceCalcScroll);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debounceCalcScroll);
  },
  methods: {
    dateSourceRowRange() {
      // this.columnsNumber = this.tableInitInfo.columnNum;
      //   this.rowsNumber = this.tableInitInfo.rowNum;
      let range = {
        start: 0,
        end: this.rowsNumber - 1
      };
      if (!this.tableForm.tableHead) {
        range.start = this.tableForm.tabHeadLineNum;
      }
      if (!this.tableForm.tableTail) {
        range.end = this.rowsNumber - 2;
      }
      console.log(range, 'range');
      return range;
    },
    limitNumber(value) {
      console.log(value, typeof value, '----------');
      if (typeof value === 'string') {
        return !isNaN(Number(value)) ? value.replace(/^(0+)|[^\d]/g, '') : 0;
      } else if (typeof value === 'number') {
        return !isNaN(value) ? String(value).replace(/^(0+)|[^\d]/g, '') : 0;
      } else {
        return 0;
      }
    },
    updateTble() {
      if (this.hot) {
        this.hot.updateSettings(this.hotSettings);
      }
    },
    newTable() {
      if (this.tableInitInfo.tableType === 'fixed') {
        this.tableForm.sortDefault = true;
      }
      //新增模板的初始化数据
      this.columnsNumber = this.tableInitInfo.columnNum;
      this.rowsNumber = this.tableInitInfo.rowNum;
      if (this.tableInitInfo.tableType === 'increment') {
        //自增表格的行没有包含表头行  总行数要加上表头行
        this.rowsNumber = this.rowsNumber + this.tableInitInfo.tableHeaderRowNum;
      }
      this.tableForm.tabHeadLineNum = this.tableInitInfo.tableHeaderRowNum;
      this.initHotSettting(); //初始化表格配置
      this.cellSettingsItem(); // 设置表头格的行列的样式数据
      //新增模板
      this.setTableInitSetting(); //设置预览区表格初始数据
      this.setCellOptions(); //设置单元格设置的行列的下拉数据
      this.setInitColumnData(this.columnsNumber); //新增的时候列设置的初始数据
      this.setMarkData(); //设置每一列的关联数据源 以及关联函数下拉数据
      this.$nextTick(() => {
        this.initTable();
      });
    },
    editTable() {
      //编辑表格初始化数据
      getContainerTemplateDetail({
        id: this.tableInitInfo.id
      }).then(res => {
        console.log(res, res.headerInfo, 'resdetail');
        //设置回显数据
        let rawData = JSON.parse(res.rawData);
        this.tableForm = {
          name: res.name,
          mark: res.mark || 'table1',
          tableHead: res.tableHead === 'YES' ? true : false,
          tableTail: res.tableTail === 'YES' ? true : false,
          autoincrement: res.autoincrement === 'YES' ? true : false,
          sortField: res.sortField || undefined,
          sort: res.sort || undefined,
          tabHeadLineNum: res.tableHeadNum || 1,
          isForm: res.isForm === 'YES' ? true : false,
          sortDefault: res.sortDefault === 'YES' ? true : false
        };
        this.tableInitInfo = {
          id: res.id,
          tableHeaderRowNum: res.tableHeadNum || 1,
          rowNum: rawData.rowNumber,
          type: 'table',
          columnNum: rawData.columnNumber,
          tableType: res.tableType,
          tableUsage: res.tableUsage
        };
        this.autoincrement = res.autoincrement === 'YES' ? true : false;
        // this.tableInitInfo.tableHeaderRowNum = res.tableHeadNum || 1;
        // this.tableInitInfo.rowNum = rawData.rowNumber;
        // this.tableInitInfo.columnNum = rawData.columnNumber;
        // this.tableInitInfo.tableType = res.tableType;
        // this.tableInitInfo.tableUsage = res.tableUsage;
        this.columnsNumber = this.tableInitInfo.columnNum;
        this.rowsNumber = this.tableInitInfo.rowNum;
        // if (this.tableInitInfo.tableType === 'increment') {
        //   //自增表格的行没有包含表头行  总行数要加上表头行
        //   this.rowsNumber = this.rowsNumber - this.tableInitInfo.tableHeaderRowNum;
        // }
        this.tableForm.tabHeadLineNum = this.tableInitInfo.tableHeaderRowNum;
        this.initHotSettting(); //初始化表格配置
        let cellStyleObj = JSON.parse(rawData.cellStyleObj);
        this.mergeCells = JSON.parse(rawData.mergeCells);
        this.headerData = JSON.parse(rawData.headerData || '[]') || [];
        let mergeCellsArr = this.formatMergeCell(this.mergeCells);
        // console.log(mergeCellsArr, this.mergeCells, 'mergeCells');
        this.cellStyleObj = cellStyleObj;
        // this.cellSettingsItem(); //设置单元格设置的行列的样式数据
        this.setCellOptions(); //设置单元格设置的行列的下拉数据
        let listInfo = JSON.parse(res.listInfo);
        // this.columns = [];
        // this.dataSource = [];
        // this.dataSource.push({});
        // if (!this.tableForm.tableTail) {
        //   this.dataSource.push({});
        // }
        // console.log(listInfo, 'listInfo');
        this.setColumnEchoData(listInfo);
        //设置排序字段回显
        let sortFieldEcho = res.sortField ? JSON.parse(res.sortField) : undefined;
        let sortFieldItem = sortFieldEcho ? this.columns.find(item => item.name === sortFieldEcho.name) : null;
        let sortField = sortFieldItem ? sortFieldItem.dataIndex : undefined;
        this.$set(this.tableForm, 'sortField', sortField);
        this.setMarkData(); //设置每一列的关联数据源 以及关联函数下拉数据
        this.$nextTick(() => {
          let data = JSON.parse(rawData.tableData);
          this.hotSettings.data = data;
          this.hotSettings.mergeCells = mergeCellsArr;
          this.initTable();
        });
        // this.dataSource = [...this.dataSource];
      });
    },
    formatMergeCell(mergeCells) {
      let mergeCellsArr = [];
      mergeCells.forEach(item => {
        let obj = {
          row: item.from.row,
          col: item.from.col,
          rowspan: item.to.row - item.from.row + 1,
          colspan: item.to.col - item.from.col + 1
        };
        mergeCellsArr.push(obj);
      });
      return mergeCellsArr;
    },
    initHotSettting() {
      //设置表格的初始配置
      const that = this;
      this.computedIndexCells(); //计算数据源行对应的序号单元格
      this.computedTableTailCells(); //计算表尾单元格
      this.computedIndexColumnsAllCell(); //计算索引列的所有单元格
      this.computedDataSourceCells(); //计算数据源区所有单元格
      // console.log(that.tableTailCells, 'that.indexCells');
      this.hotSettings = {
        data: [],
        mergeCells: true,
        height: 200,
        cells: this.disabledCell,
        afterSelectionEnd: this.afterSelectionEnd,
        contextMenu: {
          items: {
            remove_col: {
              disabled() {
                let getSelectedLast = this.getSelectedLast();
                let currentCell = getSelectedLast[0] + ',' + getSelectedLast[1];
                if (getSelectedLast[3] - getSelectedLast[1] > 0) {
                  return true;
                } else if (that.indexColumnsAllCell.indexOf(currentCell) !== -1) {
                  return true;
                } else if (that.columnsNumber < 3 && that.autoincrement || that.columnsNumber < 2 && !that.autoincrement) {
                  //校验出去序号列只剩2列的时候不能删除列
                  return true;
                } else {
                  return false;
                }
              }
            },
            mergeCells: {
              disabled() {
                let getSelectedLast = this.getSelectedLast();
                let startCell = getSelectedLast[0] + ',' + getSelectedLast[1];
                let endCell = getSelectedLast[2] + ',' + getSelectedLast[3];
                let allDisabledCell = that.computedDisabledCell();
                // console.log(that.tableTailCells, startCell, endCell, 'row,disabled');
                if (allDisabledCell.indexOf(startCell) !== -1 || allDisabledCell.indexOf(endCell) !== -1 || that.indexCells.indexOf(startCell) !== -1 || that.indexCells.indexOf(endCell) !== -1 || that.tableTailCells.indexOf(startCell) !== -1 || that.tableTailCells.indexOf(endCell) !== -1) {
                  //设置数据源区 表尾区  序号列 不能合并单元格
                  return true;
                } else {
                  return false;
                }
              }
            }
          }
        },
        className: 'htCenter htMiddle tdHeight',
        colWidths: 120,
        rowHeights: 40
      };
      if (this.tableInitInfo.tableType === 'increment') {
        //只有自增表格有在右侧插入行
        this.hotSettings.contextMenu.items.col_right = {
          disabled() {
            if (that.columnsNumber > 9) {
              //校验出去序号列只剩2列的时候不能删除列
              return true;
            } else {
              return false;
            }
          }
        };
        // console.log(this.hotSettings.contextMenu.items, 'this.hotSettings.contextMenu.items');
      }
    },
    computedAndUpdateCells() {
      this.computedTableTailCells(); //计算表尾单元格
      this.computedIndexColumnsAllCell(); //计算索引列的所有单元格
      this.computedDataSourceCells(); //计算数据源区所有单元格
      this.hot.updateSettings(this.hotSettings);
    },
    computedIndexColumnsAllCell() {
      //计算序号列的所有单元格
      this.indexColumnsAllCell = [];
      if (this.tableForm.autoincrement) {
        let rowNums = this.rowsNumber;
        // if (this.tableInitInfo.tableType === 'increment' && !this.tableForm.tableHead) {
        //   //自增表格的行要加上表头
        //   rowNums = rowNums + this.tableForm.tabHeadLineNum;
        // }
        // console.log(rowNums, 'this.rowsNumber');
        for (let j = 0; j < rowNums; j++) {
          this.indexColumnsAllCell.push(j + ',' + 0);
        }
      }
    },
    cellSettingsItem() {
      //设置单元格设置的行列的样式数据
      for (let i = 0; i < this.tableInitInfo.tableHeaderRowNum; i++) {
        for (let j = 0; j < this.columnsNumber; j++) {
          this.cellStyleObj[i + ',' + j] = JSON.parse(JSON.stringify(this.styleObjDefault));
        }
      }
    },
    setTableInitSetting() {
      // console.log(this.tableInitInfo, ' this.tableInitInfo');
      let columnNum = this.tableInitInfo.columnNum;
      let rowNum = this.tableInitInfo.rowNum;
      if (this.tableInitInfo.tableType === 'increment') {
        rowNum = rowNum + this.tableInitInfo.tableHeaderRowNum;
      }
      //容器模板的自增表格
      // let tableHeaderData = [];
      // for (let i = 1; i <= columnNum; i++) {
      //   tableHeaderData.push('column' + i);
      // }
      // console.log(tableHeaderData, 'tableHeaderData');
      // this.hotSettings.data.push(tableHeaderData);
      // for (let j = 1; j <= rowNum; j++) {
      //   let rowData = [];
      //   for (let i = 1; i <= columnNum; i++) {
      //     rowData.push('');
      //   }
      //   console.log(rowData, this.hotSettings.data, 'rowData');
      //   this.hotSettings.data.push(rowData);
      // }
      // } else if (this.tableInitInfo.tableType === 'fixed') {
      this.hotSettings.data = this.setMulLevelData(columnNum, rowNum);
      for (let i = 0; i < columnNum; i++) {
        this.hotSettings.data[0][i] = 'column' + (i + 1);
      }
      // console.log(this.hotSettings.data, 'kkkkk');
      // }
    },
    setCellOptions() {
      //设置单元格的行列的可选值
      let columnNum = this.columnsNumber;
      let rowNum = this.tableInitInfo.tableHeaderRowNum + 1;
      // console.log(columnNum, rowNum, 'columnNum,rowNum');
      this.cellSettings.rowOptions = [];
      this.cellSettings.columnOptions = [];
      for (let i = 1; i < rowNum; i++) {
        this.cellSettings.rowOptions.push({
          label: this.$t('行') + i,
          value: i - 1
        });
      }
      for (let j = 1; j <= columnNum; j++) {
        this.cellSettings.columnOptions.push({
          label: this.$t('列') + j,
          value: j - 1
        });
      }
    },
    setMulLevelData(columnNum, rowNum) {
      let data = [];
      for (let j = 1; j <= rowNum; j++) {
        let rowData = [];
        for (let i = 1; i <= columnNum; i++) {
          rowData.push('');
        }
        data.push(rowData);
      }
      return data;
    },
    setInitColumnData(columnsNumber) {
      //新增的时候设置列设置的初始数据
      this.columns = [];
      // this.dataSource = [{}];
      for (let i = 1; i <= columnsNumber; i++) {
        let dataIndex = 'column' + i;
        let defaultObj = JSON.parse(JSON.stringify(this.defaultColumnObj));
        defaultObj.functionDataSource = this.tableTailFunction || [];
        this.columns.push({
          name: 'column' + i,
          dataIndex,
          ...defaultObj
        });
        // this.$set(this.dataSource[0], dataIndex, '');
      }
    },
    setColumnEchoData2(listInfo) {
      //编辑的时候处理列设置区的回显
      this.columns = [];
      if (this.tableForm.autoincrement) {
        this.columns.push({
          name: 'No.',
          dataIndex: 'column0',
          type: undefined,
          mark: [],
          tail: '',
          function: undefined
        });
        this.$set(this.dataSource[0], 'column0', 1);
        if (!this.tableForm.tableTail) {
          this.$set(this.dataSource[1], 'column0', '');
        }
      }
      listInfo && Array.isArray(listInfo) && listInfo.forEach(async (item, index) => {
        let dataIndex = 'column' + (index + 1);
        let obj = {
          name: item.name,
          dataIndex,
          type: item.type || undefined,
          mark: item.mark || [],
          tail: item.tail || '',
          function: item.function || undefined,
          functionDataSource: this.tableTailFunction || []
        };
        this.$set(this.dataSource[0], dataIndex, item.mark || '');
        if (!this.tableForm.tableTail) {
          let value = '';
          if (item.tail && item.function) {
            value = item.tail + ':' + item.function;
          } else {
            value = item.tail || item.function;
          }
          this.$set(this.dataSource[1], dataIndex, value);
        }
        this.columns.push(obj);
      });
    },
    setColumnEchoData(listInfo) {
      this.columns = [];
      // console.log(listInfo, 'listInfoEcho');
      listInfo && Array.isArray(listInfo) && listInfo.forEach((item, index) => {
        let obj = {
          name: item.name,
          dataIndex: item.name,
          type: item.type || undefined,
          mark: item.mark || [],
          tail: item.tail || '',
          function: item.function || undefined,
          functionDataSource: this.tableTailFunction || [],
          control: item.control || 'text',
          optionValues: '',
          dateType: '',
          widthSet: item.widthSet || undefined,
          font: item.typeFace ? true : false,
          bold: item.bold === true ? true : false,
          italic: item.italic == true ? true : false,
          underline: item.underline == true ? true : false,
          fontSize: item.size ? true : false,
          fontFamily: item.typeFace ? item.typeFace : '默认字体',
          size: item.size ? item.size : '默认字号',
          activeStyleIcon: ''
        };
        if (this.tableInitInfo.tableUsage === 'control' && item.control === 'text') {
          let controlScope = item.controlScope;
          obj.textLengthMinValue = controlScope.split(',').length > 0 ? Number(controlScope.split(',')[0]) : 0;
          obj.textLengthMaxValue = controlScope.split(',').length > 1 ? Number(controlScope.split(',')[1]) : 200;
        } else if (this.tableInitInfo.tableUsage === 'control' && item.control === 'number') {
          let controlScope = item.controlScope;
          obj.numberMinValue = controlScope.split(',').length > 0 ? Number(controlScope.split(',')[0]) : 0;
          obj.numberMaxValue = controlScope.split(',').length > 1 ? Number(controlScope.split(',')[1]) : 200;
        } else if (this.tableInitInfo.tableUsage === 'control' && item.control === 'radio') {
          obj.optionValues = item.controlScope;
        } else if (this.tableInitInfo.tableUsage === 'control' && item.control === 'date') {
          obj.dateType = item.controlScope;
        }
        this.columns.push(obj);
      });
    },
    initTable() {
      //初始化表格
      this.hot = new Handsontable(this.$refs.hotTable, this.hotSettings);
      // console.log(this.hot, this.hotSettings, ' this.hotSettings');
      this.hot.addHook('afterCreateCol', this.afterCreateCol);
      this.hot.addHook('afterRemoveCol', this.afterRemoveCol);
      this.hot.addHook('afterSelectionEnd', this.afterSelectionEnd);
      this.hot.addHook('afterMergeCells', this.afterMergeCells);
      this.hot.addHook('afterUnmergeCells', this.afterUnmergeCells);
    },
    afterUnmergeCells(cellRange) {
      // console.log(cellRange, 'action');
      let index = this.mergeCells.findIndex(item => {
        return item.from.row === cellRange.from.row && item.from.col === cellRange.from.col;
      });
      this.mergeCells.splice(index, 1);
      this.hotSettings.mergeCells = this.formatMergeCell(this.mergeCells);
    },
    afterMergeCells(cellRange) {
      this.mergeCells.push(cellRange);
      this.hotSettings.mergeCells = this.formatMergeCell(this.mergeCells);
      //下面的代码是为了解决向下合并单元格下边框和右边框消失的问题
      let arr = [cellRange.from.row, cellRange.from.col, cellRange.to.row, cellRange.to.col];
      const customBordersPlugin = this.hot.getPlugin('customBorders');
      customBordersPlugin.setBorders([arr], {
        right: {
          width: 1,
          color: '#ccc'
        }
      });
      customBordersPlugin.setBorders([arr], {
        bottom: {
          width: 1,
          color: '#ccc'
        }
      });
      // customBordersPlugin.setBorders([arr], {left: {width: 1.5, color: '#ccc'}});
    },
    generateTableMark() {
      let dataTime = new Date().getTime();
      this.tableForm.mark = 'table_' + dataTime;
    },
    columnNameChange(item, index) {
      if (item.name.trim().length === 0) {
        this.$set(item, 'errorStatus', true);
        this.$set(item, 'errorMsg', this.$t('请输入列名'));
        return;
      }
      let hasSameName = this.showColumns.some((column, i) => column.name === item.name && i !== index);
      if (hasSameName) {
        this.$set(item, 'errorStatus', true);
        this.$set(item, 'errorMsg', this.$t('列名重复'));
        return;
      }
      this.$set(item, 'errorStatus', false);
      this.$set(item, 'errorMsg', '');
    },
    cellStyle({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      //设置当前设置值的单元格的样式
      let obj = {};
      if (this.activeColumnIndex === columnIndex && this.activeRowIndex === rowIndex) {
        obj.border = '2px solid #1890ff';
      }
      if (rowIndex === 0) {
        obj.backgroundColor = 'rgba(245,245,245,0.5) !important';
      }
      return obj;
    },
    async setMarkData() {
      const h = this.$createElement;
      //设置每一列的关联数据源 以及关联函数下拉数据
      const requestArr = [getTemplateDataSources({
        type: 'system'
      }), getTemplateDataSources({
        type: 'dynamic'
      }), getTemplateDataSources({
        type: 'filter'
      })];
      Promise.all(requestArr).then(res => {
        let keyMap = {}; //存储每一个末级标签的路径值
        const loop = (data, keyValue = '') => {
          return data.map(item => {
            if (item.children) {
              let key = item.mark || item.id;
              item.children = loop(item.children, keyValue ? keyValue + ',' + key : key);
              if (item.children && item.children.length == 0) {
                item.children = [{
                  value: item.id + '1',
                  label: '',
                  name: '',
                  disabledSelect: true,
                  disabled: true,
                  isLeaf: true
                }];
              }
              return {
                value: item.mark || item.id + '',
                label: item.name,
                name: item.name,
                id: item.id,
                children: item.children,
                isLeaf: false
              };
            } else {
              let resulrKeyStr = keyValue + ',' + item.mark;
              keyMap[item.mark] = resulrKeyStr.split(',');
              this.markDataMap[item.mark] = item.name; //快捷配置的数据源数据收集
              this.supportSortMap[item.mark] = item.isSupportSort;
              //末级字段自定义展示
              return {
                value: item.mark,
                name: item.name,
                id: item.id,
                isLeaf: true,
                label: h("span", {
                  "attrs": {
                    "value": item.name
                  }
                }, [item.name, h("svg-icon", {
                  "attrs": {
                    "icon": "copy",
                    "size": 20
                  },
                  "class": "copy-icon",
                  "nativeOn": {
                    "click": e => this.copyFunction(e, item)
                  }
                })])
              };
            }
          });
        };
        this.formatSystemData = loop(res[0]);
        this.formatDynamicData = loop(res[1]);
        this.formatFilterData = loop(res[2]);
        this.columns.forEach(item => {
          if (item.mark && !Array.isArray(item.mark)) {
            item.mark = keyMap[item.mark];
          }
          //设置每一列的关联数据源 的标签下拉数据
          if (item.type === 'system') {
            item.markDataSource = this.formatSystemData;
          }
          if (item.type === 'dynamic') {
            item.markDataSource = this.formatDynamicData;
          }
          if (item.type === 'filter') {
            item.markDataSource = this.formatFilterData;
          }
        });
      });
    },
    tableTailChange(value) {
      //隐藏表尾切换  隐藏表尾为false table最后添加一行
      // if (!value) {
      //   let obj = {};
      //   this.columns.forEach(item => {
      //     let value = '';
      //     if (item.tail && item.function) {
      //       value = item.tail + ':' + item.function;
      //     } else {
      //       value = item.tail || item.function;
      //     }
      //     obj[item.dataIndex] = value;
      //   });
      //   this.dataSource.push(obj);
      // } else {
      //   this.dataSource.pop();
      // }
      if (!value) {
        this.rowsNumber = this.rowsNumber + 1;
        let rowData = this.setEmptyLineData(this.columnNum);
        if (this.tableForm.autoincrement) {
          rowData.unshift('');
        }
        this.hotSettings.data.push(rowData);
      } else {
        this.hotSettings.data.pop();
        this.rowsNumber = this.rowsNumber - 1;
        this.columns.forEach((item, index) => {
          if (index === this.columns.length - 1) {
            item.function = undefined;
            item.tail = '';
          }
        });
      }
      this.computedDisabledCell();
      this.computedIndexColumnsAllCell(); //计算索引列的所有单元格
      this.computedTableTailCells(); //计算表尾单元格
      this.hot.updateSettings(this.hotSettings);
    },
    setEmptyLineData(columnsNumber) {
      let rowData = [];
      for (let i = 1; i <= columnsNumber; i++) {
        rowData.push('');
      }
      return rowData;
    },
    settingTail(e, item, index) {
      //关联函数或者合计更新的时候 更新预览区表格的标表尾行
      // if (!this.tableForm.tableTail) {
      //   this.activeColumnIndex = this.computedColumns.findIndex(column => column.dataIndex == item.dataIndex); //当前操作的列
      //   this.activeRowIndex = 1; //当前操作的行
      //   let value = '';
      //   if (item.tail && item.function) {
      //     value = item.tail + ':' + item.function;
      //   } else {
      //     value = item.tail || item.function;
      //   }
      //   this.$set(this.dataSource[1], item.dataIndex, value);
      // }
      let value = '';
      if (item.tail && item.function) {
        value = item.tail + ':' + item.function;
      } else {
        value = item.tail || item.function;
      }
      if (!this.tableForm.tableTail) {
        let tailLine = this.hotSettings.data.length - 1;
        // console.log(value, tailLine, index, 'kkkk');
        this.hotSettings.data[tailLine][index] = value;
      }
      this.hot.updateSettings(this.hotSettings);
    },
    addAutoIncreColumn() {
      // //首列自增时添加序号列
      // if (!this.tableForm.autoincrement) {
      //   this.columns.shift();
      //   this.$delete(this.dataSource[0], 'column0');
      // } else {
      //   this.columns.unshift({
      //     name: 'index',
      //     dataIndex: 'column0',
      //     type: undefined,
      //     mark: [],
      //     tail: '',
      //     function: undefined
      //   });
      //   this.$set(this.dataSource[0], 'column0', 1);
      // }
      // this.hotSettings[0].unshift('序号');
      this.columnsNumber = this.columnsNumber + 1;
      this.tableForm.autoincrement = this.tableForm.autoincrement ? false : true;
      if (!this.tableForm.autoincrement) {
        this.hotSettings.data.forEach((rowData, index) => {
          rowData.shift();
        });
      } else {
        this.hotSettings.data.forEach((rowData, index) => {
          if (index === 0) {
            rowData.unshift('序号');
          } else if (!this.tableForm.tableTail && index !== this.hotSettings.data.length - 1 || this.tableForm.tableTail) {
            rowData.unshift(index);
          }
        });
      }
      // console.log(this.hotSettings.data, 'this.hotSettings.data');
      this.computedAndUpdateCells();
      // this.computedIndexCells();
      // this.computedIndexColumnsAllCell(); //计算索引列的所有单元格
      // this.computedDataSourceCells(); //计算数据源区所有单元格
      // this.hot.updateSettings(this.hotSettings);
    },
    addRow() {
      // let hasIndex = this.columns.some(item => item.dataIndex === 'column0');
      // let index = hasIndex ? this.columns.length : this.columns.length + 1;
      // if (this.columns.length >= 9) {
      //   this.$message.destroy();
      //   this.$message.error(this.$t('最多添加9列'));
      //   return;
      // }
      // this.columns.push({
      //   name: 'column' + index,
      //   dataIndex: 'column' + index,
      //   type: undefined,
      //   mark: [],
      //   tail: '',
      //   function: undefined,
      //   functionDataSource: this.functionResource || []
      // });
    },
    onMarkChange(value, selectedOptions, item, index) {
      let dataSourceLine;
      if (this.tableForm.tableHead) {
        dataSourceLine = 0;
      } else {
        dataSourceLine = this.tableForm.tabHeadLineNum;
      }
      let columnIndex = this.tableForm.autoincrement ? index + 1 : index;
      this.hotSettings.data[dataSourceLine][columnIndex] = value[value.length - 1];
      this.hot.updateSettings(this.hotSettings);
      // }
      //选择关联数据源的标签后 更新预览区表格的标签值
      // if (item.disabledSelect) {
      //   return;
      // }
      // this.activeColumnIndex = this.computedColumns.findIndex(column => column.dataIndex == item.dataIndex); //当前操作的列
      // this.activeRowIndex = 0; //当前操作的行
      // this.$set(this.dataSource[0], item.dataIndex, value[value.length - 1]);
      // this.markDataMap[value[value.length - 1]] = selectedOptions[selectedOptions.length - 1].name;
    },
    typeChange(record) {
      if (!record.type) {
        return;
      }
    },
    copyFunction(e, item) {
      e.stopPropagation();
      clickCopy(item.mark);
    },
    copyFunction2(e, item) {
      let copyValue = '${' + this.tableForm.mark + '.' + item.mark + '()' + '}';
      clickCopy(copyValue);
    },
    validateEmptyDataSource() {
      //校验是否有空数据行
      let markEmpty = false;
      const columnName = [];
      this.columns.forEach((item, index) => {
        if (item.name !== 'column1' || item.name === 'column1' && !this.tableForm.autoincrement) {
          let mark = item.mark && item.mark.length > 0 && Array.isArray(item.mark) ? item.mark[item.mark.length - 1] : item.mark || '';
          if ((!mark || mark && mark.length === 0) && !(index === 0 && this.autoincrement)) {
            markEmpty = true;
          }
        }
        if (columnName.indexOf(item.name) === -1) {
          columnName.push(item.name);
        }
      });
      if (markEmpty && this.$route.params.type === 'table') {
        this.$message.error(this.$t('存在未绑定数据源的列'));
        return false;
      }
      if (columnName.length !== this.columns.length) {
        this.$message.error(this.$t('存在列名重复'));
        return false;
      }
      return true;
    },
    formatHeaderInfo() {
      let data = this.hot.getData();
      let headerData;
      if (this.tableForm.tableHead) {
        headerData = this.headerData;
      } else {
        headerData = data.splice(0, this.tableInitInfo.tableHeaderRowNum);
        this.headerData = headerData;
      }
      // console.log(headerData, 'headerData');
      this.headerData = headerData;
      let arr = [];
      this.widthSets = [];
      this.columns.forEach((item, index) => {
        if (item.widthSet) {
          this.widthSets.push(item.widthSet.replace('%', ''));
        } else {
          this.widthSets.push(0);
        }
      });
      headerData.forEach((lineData, rowIndex) => {
        arr[rowIndex] = [];
        lineData.forEach((item, lineIndex) => {
          let cellStyleObj = this.cellStyleObj[rowIndex + ',' + lineIndex];
          let obj = {
            row: rowIndex,
            col: lineIndex,
            text: item || '',
            vMerge: '',
            gridSpan: '',
            widthSet: this.widthSets[lineIndex] || '',
            typeFace: cellStyleObj.typeFace === '默认字体' ? '' : cellStyleObj.typeFace,
            bold: cellStyleObj.bold,
            italic: cellStyleObj.italic,
            underline: cellStyleObj.underline,
            size: cellStyleObj.size === '默认字号' ? '' : cellStyleObj.size,
            bgColor: cellStyleObj.bgColorValue ? cellStyleObj.bgColorValue : '',
            prefix: cellStyleObj.prefix || '',
            suffix: cellStyleObj.suffix || '',
            control: cellStyleObj.control || '',
            valign: cellStyleObj.valign || 'center'
          };
          let controlScope = '';
          if (cellStyleObj.control === 'text') {
            let min = Number(cellStyleObj.textLengthMinValue) || 0;
            let max = Number(cellStyleObj.textLengthMaxValue) || 200;
            controlScope = min + ',' + max;
          } else if (cellStyleObj.control === 'date') {
            controlScope = cellStyleObj.dateType;
          } else if (cellStyleObj.control === 'radio') {
            controlScope = cellStyleObj.optionValues;
          }
          obj.controlScope = controlScope;
          arr[rowIndex].push(obj);
        });
      });
      if (this.mergeCells.length > 0) {
        //更具合并信息处理数据
        this.mergeCells.forEach(item => {
          let {
            from,
            to
          } = item;
          let rowSpan = to.row - from.row;
          let lineSpan = to.col - from.col;
          if (lineSpan > 0 && rowSpan === 0) {
            //向右合并
            arr[from.row][from.col].gridSpan = lineSpan + 1;
            arr[from.row][from.col].vMerge = 'restart';
            // arr[from.row][from.col].width = this.computedWidth(from, lineSpan);
            let col = from.col;
            while (lineSpan > 0) {
              arr[from.row][++col].isMerged = true;
              lineSpan--;
            }
          }
          if (rowSpan > 0 && lineSpan === 0) {
            //向下合并
            arr[from.row][from.col].vMerge = 'restart';
            let startRow = from.row;
            while (rowSpan > 0) {
              arr[++startRow][from.col].vMerge = 'continue';
              rowSpan--;
            }
          }
          if (rowSpan > 0 && lineSpan > 0) {
            //既向下又向右合并
            for (let i = from.row; i <= to.row; i++) {
              for (let j = from.col; j <= to.col; j++) {
                if (i === from.row && j === from.col) {
                  arr[i][j].gridSpan = lineSpan + 1;
                  // arr[from.row][from.col].width = this.computedWidth(from, lineSpan);
                  arr[i][j].vMerge = 'restart';
                } else if (i === from.row && j !== from.col) {
                  arr[i][j].isMerged = true;
                } else if (i !== from.row && j === from.col) {
                  arr[i][j].vMerge = 'continue';
                  arr[i][j].gridSpan = lineSpan + 1;
                } else if (i !== from.row && j !== from.col) {
                  arr[i][j].vMerge = 'continue';
                  arr[i][j].isMerged = true;
                }
              }
            }
          }
        });
      }
      console.log(arr, 'arr77777');
      return JSON.stringify(arr);
    },
    computedWidth(item, rowSpan) {
      let start = item.col;
      let end = item.col + rowSpan;
      console.log(start, end, this.widthSets, 'start,end');
      let width = '';
      // debugger;
      for (let i = start; i <= end; i++) {
        width = Number(width) + Number(this.widthSets[i]);
      }
      return width + '%';
    },
    saveTable() {
      // console.log(this.mergeCells, 'mergeCellssave');
      let tableData = this.hot.getData();
      let numberTypeColumns = [];
      this.columns.forEach((item, index) => {
        if (item.control === 'number') {
          numberTypeColumns.push(index);
        }
      });
      let typeValidate = {
        status: true
      };
      // console.log(tableData, 'numberTypeColumns');
      if (numberTypeColumns.length > 0) {
        let dateSourceRowRange = this.dateSourceRowRange();
        tableData.forEach((rowData, i) => {
          if (i >= dateSourceRowRange.start && i <= dateSourceRowRange.end) {
            rowData.forEach((item, index) => {
              if (numberTypeColumns.indexOf(index) > -1) {
                let reg = /^[0-9]*$/;
                if (item && !reg.test(item) && typeValidate.status) {
                  typeValidate.status = false;
                  let msg = this.$t('第0行第1列数据不是数字类型').repelace('0', i + 1).replace('1', index + 1);
                  typeValidate.msg = msg;
                }
              }
            });
          }
        });
      }
      if (!typeValidate.status) {
        this.$message.error(typeValidate.msg);
        return;
      }
      let rowDatas = {
        rowNumber: this.rowsNumber,
        columnNumber: this.columnsNumber,
        tableData: JSON.stringify(tableData),
        cellStyleObj: JSON.stringify(this.cellStyleObj),
        mergeCells: JSON.stringify(this.mergeCells),
        headerData: JSON.stringify(this.headerData)
      };
      let params = {
        type: this.tableInitInfo.type,
        name: this.tableForm.name,
        mark: this.tableForm.mark,
        tableType: this.tableInitInfo.tableType,
        tableUsage: this.tableInitInfo.tableUsage,
        tableHeadNum: this.tableInitInfo.tableHeaderRowNum,
        isForm: this.tableForm.isForm ? 'YES' : 'NO',
        tableHead: this.tableForm.tableHead ? 'YES' : 'NO',
        tableTail: this.tableForm.tableTail ? 'YES' : 'NO',
        sortField: this.tableForm.sortField || '',
        sort: this.tableForm.sort || '',
        autoincrement: this.autoincrement ? 'YES' : 'NO',
        sortDefault: this.tableForm.sortDefault ? 'YES' : 'NO',
        rawData: JSON.stringify(rowDatas),
        fixedColumnInfo: '1'
      };
      // 校验是否有空数据行
      if (!this.validateEmptyDataSource()) {
        return;
      }
      if (params.sortField) {
        let sortFieldItem = this.columns.find(item => item.dataIndex === params.sortField);
        if (sortFieldItem) {
          let obj = {
            name: sortFieldItem.name,
            mark: sortFieldItem.mark[sortFieldItem.mark.length - 1]
          };
          params.sortField = JSON.stringify(obj);
        } else {
          params.sortField = '';
        }
      }
      //处理列设置信息
      let listInfo = [];
      this.columns.forEach(item => {
        if (item.dataIndex !== 'column0') {
          let mark = item.mark && item.mark.length > 0 && Array.isArray(item.mark) ? item.mark[item.mark.length - 1] : item.mark || '';
          let obj = {
            name: item.name,
            type: item.type || '',
            mark: mark.length === 0 ? '' : mark,
            tail: item.tail,
            function: item.function || '',
            widthSet: item.widthSet || '',
            typeFace: item.fontFamily === '默认字体' ? '' : item.fontFamily,
            bold: item.bold,
            italic: item.italic,
            underline: item.underline,
            size: item.size === '默认字号' ? '' : item.size
          };
          if (this.tableInitInfo.tableUsage === 'control') {
            obj.control = item.control;
            obj.mark = item.name;
            let controlScope = '';
            if (item.control === 'text') {
              let min = Number(item.textLengthMinValue) || 0;
              let max = Number(item.textLengthMaxValue) || 200;
              controlScope = min + ',' + max;
            } else if (item.control === 'date') {
              controlScope = item.dateType;
            } else if (item.control === 'radio') {
              controlScope = item.optionValues;
            } else if (item.control === 'number') {
              let min = Number(item.numberMinValue) || 0;
              let max = Number(item.numberMaxValue) || 200;
              controlScope = min + ',' + max;
            }
            obj.controlScope = controlScope;
          }
          listInfo.push(obj);
        }
      });
      params.listInfo = JSON.stringify(listInfo);
      this.formatHeaderInfo();
      params.headerInfo = this.formatHeaderInfo();
      if (this.tableInitInfo.id === -1) {
        this.addTableRequest(params);
      } else {
        params.id = this.tableInitInfo.id;
        this.editTableRequest(params);
      }
    },
    addTableRequest(params) {
      this.loading = true;
      //新增模板提交
      addContainerTemplate(params).then(res => {
        this.loading = false;
        if (res.id) {
          this.$message.success(this.$t('新增成功'));
          if (this.tableInitInfo.tableUsage === 'control') {
            this.$emit('saveData', res);
            sessionStorage.removeItem('tableInitInfo');
          } else {
            // sessionStorage.removeItem('templateTableInitInfo');
            //先更新路由 有新增变成编辑
            this.$router.push({
              name: 'containerTemplateTableDesign',
              params: {
                id: res.id,
                type: this.tableInitInfo.tableUsage,
                row: this.rowsNumber
              }
            });
            setTimeout(() => {
              this.$router.push({
                name: 'containerTemplateComponent'
              });
            }, 500);
          }
        }
      }).catch(e => {
        this.loading = false;
      });
    },
    editTableRequest(params) {
      this.loading = true;
      //编辑模板提交
      editContainerTemplate(params).then(res => {
        this.loading = false;
        if (res.id) {
          this.$message.success(this.$t('编辑成功'));
          if (this.tableInitInfo.tableUsage === 'control') {
            this.$emit('saveData', res);
            sessionStorage.removeItem('tableInitInfo');
          } else {
            // sessionStorage.removeItem('templateTableInitInfo');
            this.$router.push({
              name: 'containerTemplateComponent'
            });
          }
        }
      }).catch(e => {
        this.loading = false;
      });
    },
    toQuickConfig(mark) {
      let list = [];
      this.showColumns.forEach(item => {
        if (item.mark && item.mark.length > 0) {
          let key = item.mark[item.mark.length - 1];
          list.push({
            label: this.markDataMap[key],
            mark: key
          });
        }
      });
      if (mark) {
        sessionStorage.setItem('defaultSelect', mark);
      } else {
        sessionStorage.setItem('defaultSelect', '');
      }
      sessionStorage.setItem('quickConfigList', JSON.stringify(list));
      this.configVisiable = true;
    },
    sortFieldSelect(e) {
      console.log(e, 'eeee');
      if (!e && this.tableInitInfo.tableUsage === 'template') {
        this.$message.destroy();
        this.$message.error(this.$t('请先设置数据源'));
      }
    },
    dataSourceComputed(item) {
      if ((item === null || item === void 0 ? void 0 : item.type) === 'system') {
        return this.computedFormatSystemData;
      } else if ((item === null || item === void 0 ? void 0 : item.type) === 'dynamic') {
        return this.computedFormatDynamicData;
      } else if ((item === null || item === void 0 ? void 0 : item.type) === 'filter') {
        return this.computedFormatFilterData;
      } else {
        return [];
      }
    },
    computedTableTailCells() {
      //计算表尾单元格
      this.tableTailCells = [];
      if (!this.tableForm.tableTail) {
        let tableTailRowNum = this.rowsNumber - 1;
        // if (this.tableInitInfo.tableType === 'increment' && !this.tableForm.tableHead) {
        //   //自增表格的行要加上表头
        //   tableTailRowNum = tableTailRowNum + this.tableForm.tabHeadLineNum;
        // }
        // let tableTailRowNum = this.rowsNumber - 1;
        for (let i = 0; i < this.columnsNumber; i++) {
          this.tableTailCells.push(tableTailRowNum + ',' + i);
        }
      }
    },
    disabledCell(row, col) {
      //禁用单元格 以及自定义单元格样式
      const that = this;
      function cellStyleRenderer(instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        td.style.background = '#f1f1fe';
        td.style.height = '39px';
      }
      function cellHeightRenderer(instance, td) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        td.style.height = '39px';
      }
      let cellProperties = {};
      //合并后会出现单元格高度不正常  设置高度
      cellProperties.renderer = cellHeightRenderer;
      let currentValue = row + ',' + col;
      if (this.tableInitInfo.tableType === 'increment' && this.dataSourceCells.indexOf(currentValue) !== -1 || this.indexCells.indexOf(currentValue) !== -1 || this.tableTailCells.indexOf(currentValue) !== -1) {
        cellProperties.readOnly = true;
        cellProperties.editor = false;
      }
      if (this.cellStyleObj[currentValue] && this.cellStyleObj[currentValue].bgColorValue) {
        function cellBgcolorRenderer(instance, td, row, col, prop, value, cellProperties) {
          Handsontable.renderers.TextRenderer.apply(this, arguments);
          td.style.background = color;
          td.style.height = '39px';
        }
        let color = this.cellStyleObj[currentValue].bgColorValue;
        cellProperties.renderer = cellBgcolorRenderer;
      }
      // console.log(this.dataSourceCells, 'this.dataSourceCells');
      if (this.dataSourceCells.indexOf(currentValue) !== -1) {
        //设置数据源样式
        cellProperties.renderer = cellStyleRenderer;
      }
      return cellProperties;
    },
    computedDataSourceCells() {
      //计算数据源的单元格
      this.dataSourceCells = [];
      if (this.tableInitInfo.tableType === 'increment') {
        let dataSourceRow = this.tableForm.tableHead ? 0 : this.tableForm.tabHeadLineNum; //隐藏表头的时候第0行是数据源行
        for (let i = 0; i < this.columnsNumber; i++) {
          this.dataSourceCells.push(dataSourceRow + ',' + i);
        }
      } else {
        // let startRowNum = this.tableForm.tableHead ? 0 : this.tableForm.tabHeadLineNum;
        // let endRowNum = this.tableForm.tableTail ? this.rowsNumber : this.rowsNumber - 1;
        let dateSourceRowRange = this.dateSourceRowRange();
        for (let i = dateSourceRowRange.start; i <= dateSourceRowRange.end; i++) {
          for (let j = 0; j < this.columnsNumber; j++) {
            // if (!(this.tableForm.autoincrement && j === 0)) {
            this.dataSourceCells.push(i + ',' + j);
            // }
          }
        }
      }
    },
    computedIndexCells() {
      //计算自增表格的序号列
      this.indexCells = [];
      if (this.autoincrement && this.tableInitInfo.tableType === 'increment') {
        //自增表格的序号单元格
        let dataSourceRow = this.tableForm.tableHead ? 0 : this.tableForm.tabHeadLineNum; //隐藏表头的时候第0行是数据源行
        this.indexCells.push(dataSourceRow + ',' + 0);
      } else if (this.autoincrement && this.tableInitInfo.tableType === 'fixed') {
        //固定表格的序号的单元格
        // let startRowNum = this.tableForm.tableHead ? 0 : this.tableForm.tabHeadLineNum;
        // let endRowNum = this.tableForm.tableTail ? this.rowsNumber : this.rowsNumber - 1;
        let dateSourceRowRange = this.dateSourceRowRange();
        for (let i = dateSourceRowRange.start; i <= dateSourceRowRange.end; i++) {
          this.indexCells.push(i + ',' + '0');
        }
      }
    },
    computedDisabledCell() {
      //计算禁用单元格
      if (this.tableInitInfo.tableType === 'increment') {
        let dataSourceRow = this.tableForm.tableHead ? 0 : this.tableForm.tabHeadLineNum; //隐藏表头的时候第0行是数据源行
        let value = [];
        for (let j = dataSourceRow; j < this.rowsNumber; j++) {
          for (let i = 0; i < this.columnsNumber; i++) {
            value.push(j + ',' + i);
          }
        }
        return value;
      } else {
        // let startRowNum = this.tableForm.tableHead ? 0 : this.tableForm.tabHeadLineNum;
        let value = [];
        // let endRowNum = this.tableForm.tableTail ? this.rowsNumber : this.rowsNumber - 1;
        let dateSourceRowRange = this.dateSourceRowRange();
        for (let i = dateSourceRowRange.start; i < this.rowsNumber; i++) {
          for (let j = 0; j < this.columnsNumber; j++) {
            // if (!(this.tableForm.autoincrement && j === 0)) {
            value.push(i + ',' + j);
            // }
          }
        }
        return value;
      }
    },
    columnStyleSetting(key, item, index) {
      if (index === 0 && this.autoincrement) {
        return;
      }
      item.activeStyleIcon = key;
      let value = !item[key];
      if (key === 'font') {
        value = item.fontFamily !== '默认字体' ? true : !item[key];
      } else if (key === 'fontSize') {
        value = item.size !== '默认字号' ? true : !item[key];
      }
      this.$set(item, key, value);
      // item[key] = true;
    },
    afterCreateCol(index, amount, source) {
      this.columnsNumber = this.columnsNumber + 1; //更新列数
      this.setCellOptions(); //更新单元格可选行列的下拉数据
      //更新之前设置单元格数据
      let obj = {};
      for (let i = 0; i < this.tableInitInfo.tableHeaderRowNum; i++) {
        for (let j = 0; j < this.columnsNumber; j++) {
          if (j < index) {
            obj[i + ',' + j] = this.cellStyleObj[i + ',' + j];
          } else if (j === index) {
            obj[i + ',' + j] = JSON.parse(JSON.stringify(this.styleObjDefault));
          } else if (j > index) {
            obj[i + ',' + j] = this.cellStyleObj[i + ',' + (j - 1)];
          }
        }
      }
      this.cellStyleObj = JSON.parse(JSON.stringify(obj));
      //插入列后更新设置面板列设置的列数据
      this.columns.splice(index, 0, JSON.parse(JSON.stringify(this.defaultColumnObj)));
      // console.log(this.columns, this.hotSettings.data, '----afterCreateCol');
      this.columns.forEach((item, i) => {
        let num = i + 1;
        item.name = 'column' + num;
        item.dataIndex = 'column' + num;
        item.functionDataSource = this.tableTailFunction;
        return item;
      });
      this.computedAndUpdateCells();
      // console.log(index, amount, source, '----afterCreateCol');
    },
    afterRemoveCol(index) {
      // console.log(index, '----afterRemoveCol');
      this.columnsNumber = this.columnsNumber - 1; //更新列数
      this.setCellOptions(); //更新单元格可选行列的下拉数据
      let obj = {};
      // console.log(this.cellStyleObj, 'this.cellStyleObj');
      for (let i = 0; i < this.tableInitInfo.tableHeaderRowNum; i++) {
        for (let j = 0; j < this.columnsNumber; j++) {
          if (j < index) {
            let oldObj = this.cellStyleObj[i + ',' + j];
            obj[i + ',' + j] = oldObj ? JSON.parse(JSON.stringify(oldObj)) : JSON.parse(JSON.stringify(this.styleObjDefault));
          } else {
            let oldObj = this.cellStyleObj[i + ',' + (j + 1)];
            obj[i + ',' + j] = oldObj ? JSON.parse(JSON.stringify(oldObj)) : JSON.parse(JSON.stringify(this.styleObjDefault));
          }
        }
      }
      this.cellStyleObj = JSON.parse(JSON.stringify(obj));
      this.updateCurrentCellObj();
      //插入列后更新设置面板列设置的列数据
      this.columns.splice(index, 1);
      this.columns.forEach((item, i) => {
        let num = i + 1;
        item.name = 'column' + num;
        item.dataIndex = 'column' + num;
        return item;
      });
      this.computedAndUpdateCells();
    },
    updateCurrentCellObj() {
      let current = this.cellSettings.selectRowKey + ',' + this.cellSettings.selectColumnKey;
      let currentObj = this.cellStyleObj[current];
      this.computedCurrentStyleObj = currentObj ? currentObj : {};
    },
    afterSelectionEnd(r, c, r2, c2) {
      console.log(r, c, r2, c2, '------------afterSelection');
      let allDisabledCell = this.computedDisabledCell();
      let currentCell = r + ',' + c;
      console.log(currentCell, allDisabledCell, 'currentCell');
      if (allDisabledCell.indexOf(currentCell) !== -1) {
        return;
      }
      this.cellSettings.selectRowKey = r;
      this.cellSettings.selectColumnKey = c;
    },
    cellStyleSetting(key) {
      this.computedCurrentStyleObj['activeStyleIcon'] = key;
      if (key === 'font') {
        let value = this.computedCurrentStyleObj.fontFamily !== '默认字体' ? true : !this.computedCurrentStyleObj[key];
        this.computedCurrentStyleObj[key] = value;
      } else {
        let value = !this.computedCurrentStyleObj[key];
        this.computedCurrentStyleObj[key] = value;
      }
    },
    tableHeaderSwitch(value) {
      //切换表头显示隐藏
      if (value) {
        let newData = [];
        this.headerData = [];
        this.hotSettings.data.forEach((item, index) => {
          if (index < this.tableForm.tabHeadLineNum) {
            this.headerData.push(item);
          } else {
            newData.push(item);
          }
        });
        this.hotSettings.data = newData;
      } else {
        this.hotSettings.data = [...this.headerData, ...this.hotSettings.data];
      }
      this.computedAndUpdateCells();
      // this.computedIndexCells();
      // this.computedIndexColumnsAllCell(); //计算索引列的所有单元格
      // this.computedDataSourceCells(); //计算数据源区所有单元格
      // this.hot.updateSettings(this.hotSettings);
    },
    handleSure() {
      this.addPrefixOrSuffixVisible = false;
      let value = this.prefixOrSuffix;
      if (this.addType === 'prefix') {
        console.log(this.$refs['prefixInput'], 'this.$refs["prefixInput"]');
        setTimeout(() => {
          this.$refs['prefixInput'].blur();
        }, 0);
        // this.$nextTick(() => {
        //   this.$refs['prefixInput'].blur();
        // });
        // this.$refs['prefixInput'].blur();
      }
      if (this.addType === 'suffix') {
        setTimeout(() => {
          this.$refs['suffixInput'].blur();
        }, 0);
      }
      let current = this.cellSettings.selectRowKey + ',' + this.cellSettings.selectColumnKey;
      if (this.cellStyleObj[current]) {
        let key = this.addType === 'prefix' ? 'prefix' : 'suffix';
        this.cellStyleObj[current][key] = value;
      }
      this.addType = '';
      this.prefixOrSuffix = '';
    },
    cancelAdd() {
      if (this.addType === 'prefix') {
        console.log(this.$refs['prefixInput'], 'this.$refs["prefixInput"]');
        setTimeout(() => {
          this.$refs['prefixInput'].blur();
        }, 0);
      }
      if (this.addType === 'suffix') {
        setTimeout(() => {
          this.$refs['suffixInput'].blur();
        }, 0);
      }
      this.addPrefixOrSuffixVisible = false;
      this.addType = '';
      this.prefixOrSuffix = '';
    },
    handleAddPrefixSuffix(type) {
      this.addType = type;
      if (this.addType === 'prefix') {
        console.log(this.$refs['prefixInput'], 'this.$refs["prefixInput"]');
        setTimeout(() => {
          this.$refs['prefixInput'].blur();
        }, 0);
      }
      if (this.addType === 'suffix') {
        setTimeout(() => {
          this.$refs['suffixInput'].blur();
        }, 0);
      }
      this.prefixOrSuffix = this.addType === 'prefix' ? this.computedCurrentStyleObj.prefix : this.computedCurrentStyleObj.suffix;
      this.addPrefixOrSuffixVisible = true;
    },
    computedValue(value) {
      let findItem = this.controlCellOptions.filter(item => item.value === value);
      return findItem && findItem.length > 0 ? findItem[0].label : '';
    },
    handleBgColorChange() {
      this.hotSettings.mergeCells = this.formatMergeCell(this.mergeCells);
      this.hot.updateSettings(this.hotSettings);
    },
    changeAutoIncrement(e, item) {
      e.preventDefault();
      e.stopPropagation();
      this.autoincrement = !this.autoincrement;
      let dateSourceRowRange = this.dateSourceRowRange();
      if (!this.autoincrement) {
        console.log(dateSourceRowRange, 'this.hotSettings.data');
        this.hotSettings.data.forEach((rowData, index) => {
          if (index >= dateSourceRowRange.start && index <= dateSourceRowRange.end) {
            rowData[0] = '';
          }
        });
      } else {
        let idx = 1;
        this.hotSettings.data.forEach((rowData, index) => {
          if (index >= dateSourceRowRange.start && index <= dateSourceRowRange.end) {
            rowData[0] = idx;
            idx++;
          }
        });
        let obj = JSON.parse(JSON.stringify(this.defaultColumnObj));
        obj.name = 'column1';
        obj.dataIndex = 'column1';
        obj.functionDataSource = this.tableTailFunction;
        this.$set(this.columns, 0, obj);
        if (this.tableForm.sortField === 'column1') {
          this.tableForm.sortField = '';
        }
      }
      this.computedAndUpdateCells();
      // console.log(this.hotSettings.data, 'this.hotSettings.data');
      // this.computedIndexCells();
      // this.computedIndexColumnsAllCell(); //计算索引列的所有单元格
      // this.computedDataSourceCells(); //计算数据源区所有单元格
      // this.hot.updateSettings(this.hotSettings);
    },
    controlChange(e, item) {
      console.log(e, item, 'controlChange');
      if (e === 'radio') {
        this.$set(item, 'optionValues', '');
      } else if (e === 'text') {
        this.$set(item, 'textLengthMinValue', 0);
        this.$set(item, 'textLengthMaxValue', 200);
      } else if (e === 'date') {
        this.$set(item, 'dateType', '');
      }
    }
  }
};